<template>
  <div>
    <div class="intro-y flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-5">
        {{ $t('dashboard.lendingDaily') }}
      </h2>
    </div>
    <div class="intro-y box p-5 mt-5">
      <!-- <div v-if="report.loan" class="flex flex-col xl:flex-row xl:items-center">
        <div class="flex flex-col sm:flex-row">
          <div>
            <div class="text-theme-20 dark:text-gray-300 text-lg xl:text-xl font-bold">
              {{ amountOfThisMonth | currency }}
            </div>
            <div class="text-gray-600 dark:text-gray-600">
              {{ $t('dashboard.totalLoanAmountOfThisMonth') }}
            </div>
          </div>
          <div
            class="h-px sm:w-px sm:h-12 border border-t sm:border-r border-dashed border-gray-300 dark:border-dark-5 my-4 sm:my-0 sm:mx-4 xl:mx-6"
          ></div>
          <div>
            <div class="text-gray-600 dark:text-gray-600 text-lg xl:text-xl font-medium">
              {{ amountOfPrevMonth | currency }}
            </div>
            <div class="text-gray-600 dark:text-gray-600">
              {{ $t('dashboard.totalLoanAmountOfPrevMonth') }}
            </div>
          </div>
        </div>
      </div> -->
      <div v-if="report.loan" class="report-chart">
        <DashboardLendingByMonthChart :list="loanChartData" :height="310" class="mt-6" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardLendingByMonthChart from '@/components/dashboard/DashboardLendingByMonthChart';
import moment from 'moment';

export default {
  props: {
    report: Object,
  },

  components: {
    DashboardLendingByMonthChart,
  },

  computed: {
    amountOfThisMonth() {
      if (this.report.loan?.thisMonth) {
        return this.report.loan.thisMonth.amount;
      }
      return 0;
    },
    amountOfPrevMonth() {
      if (this.report.loan?.prevMonth) {
        return this.report.loan.prevMonth.amount;
      }
      return 0;
    },
    loanChartData() {
      const loans = this.report.loan.date;
      if (loans.loanIssued.length > 0 && loans.loanPaid.length > 0) {
        const issuedLoans = loans.loanIssued
          .filter(loanIssued =>
            loans.loanPaid.find(loanPaid => loanPaid.newDate === loanIssued.newDate)
          )
          .map(item => {
            return item.data;
          });
        const paidLoans = loans.loanPaid
          .filter(loanPaid =>
            loans.loanIssued.find(loanIssued => loanIssued.newDate === loanPaid.newDate)
          )
          .map(item => {
            return item.data;
          });
        const labels = loans.loanIssued.map(item => {
          return moment(item.newDate, 'YYYY-MM-DD').format('D');
        });
        return {
          labels,
          issuedLoans,
          paidLoans,
        };
      }

      return {
        labels: [],
        issuedLoans: [],
        paidLoans: [],
      };
    },
  },
};
</script>
